import { e as error } from "../../../../chunks/index.js";
const load = async ({ fetch, params }) => {
  let res;
  try {
    res = await fetch(`https://admin.firstlandings.com/api/blog/posts`);
    const posts = await res.json();
    res = await fetch(`https://admin.firstlandings.com/api/blog/posts/${params.slug}`);
    const post = await res.json();
    if (post.detail) {
      throw error(404, "Post not Found");
    }
    res = await fetch(`https://admin.firstlandings.com/api/blog/sections`);
    let sections = await res.json();
    sections = sections.filter((el) => {
      return el.post == post.id;
    });
    post.sections = sections;
    res = await fetch(`https://admin.firstlandings.com/api/blog/post-tags`);
    const tags = await res.json();
    const tagMap = {};
    tags.forEach((tag) => {
      tagMap[tag.id] = tag.name;
    });
    post.tags = post.tags.map((tagId) => {
      const tag = tags.find((tag2) => tag2.id === tagId);
      return tag ? tag.name : null;
    });
    return { posts, post };
  } catch (e) {
    throw error(e?.status, `${e?.body.message}`);
  }
};
export {
  load
};
